import { initializeBrowserTelemetry } from './browserTelemetry';
import { initializeJqMigrateTelemetry } from './jqMigrateTelemetry';

initializeBrowserTelemetry();
initializeJqMigrateTelemetry();
